if ( typeof AnnouncementBar !== 'function' ) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;

      // Auto slide settings
      this.autoSlideDelay = 4000; // 4 seconds
      this.autoSlideTimer = null;

      this.nextButton.addEventListener('click', () => {
        this.changeSlide('next');
        this.resetAutoSlide();
      });

      this.prevButton.addEventListener('click', () => {
        this.changeSlide('prev');
        this.resetAutoSlide();
      });

      this.startAutoSlide();
    }

    startAutoSlide() {
      if (this.length <= 1) return;

      this.autoSlideTimer = setInterval(() => {
        this.changeSlide('next', true);
      }, this.autoSlideDelay);
    }

    resetAutoSlide() {
      clearInterval(this.autoSlideTimer);
      this.startAutoSlide();
    }

    changeSlide(direction, isAuto = false) {
      this.nextButton.classList.remove('announcement-bar__content-nav--disabled');
      this.prevButton.classList.remove('announcement-bar__content-nav--disabled');

      if (direction === 'next') {
        this.index++;
      } else if (direction === 'prev') {
        this.index--;
      }

      // 🔁 Loop behavior for auto slide
      if (this.index >= this.length) {
        this.index = 0;
      } else if (this.index < 0) {
        this.index = this.length - 1;
      }

      // Disable arrows (manual only)
      if (!isAuto) {
        if (this.index === this.length - 1) {
          this.nextButton.classList.add('announcement-bar__content-nav--disabled');
        } else if (this.index === 0) {
          this.prevButton.classList.add('announcement-bar__content-nav--disabled');
        }
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });
    }
  }

  if ( typeof customElements.get('announcement-bar') === 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
  }
}